<template>
    <div class="news-list-item  tapable_el" @click.stop="openContent()" tapmode  >
        <div class="news-list-item-card">
            <div class="news-list-item-title news-list-item-bigDesc" v-html="data.title"></div>
            <div class="news-list-item-bigimg" >
                <img v-if="data.thumb"  @error="setdefaultImg($event)" v-lazy="data.thumb[0]+'?x-oss-process=image/resize,m_lfit,h_470,w_800'" class="news-list-item-bigimg-img">
            </div>
            <div class="news-list-item-desc text-overflow3" >
                {{data.desc}}
                <span>
                <svg class="icon" viewBox="0 0 1024 1024" width="100" height="100"><path d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z" p-id="2340"></path></svg>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import utils from "../utils";

    export default {
        name: "bigImgDesc",
        props: {
            data: Object,
            is_spec: Boolean,
            nav_url: String,
            title: String,
        },
        methods: {
            setdefaultImg(event) {
                var el = event.currentTarget;
                el.style.opacity = 0
            },
            openContent() {
                if (this.data.art_link) {
                    utils.openPage(this.data,this)
                } else {
                    this.$router.push({name: "NewsContent", params: {id: this.data.art_id}})
                }

            }
        },
    }
</script>

<style scoped>

</style>
